import {Backdrop, Box, Divider, IconButton, SwipeableDrawer, Toolbar, Typography} from "@mui/material";
import Gallery from "./Gallery";
import React from "react";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@mui/styles";
import PropTypes from 'prop-types';
import CloseIcon from "@mui/icons-material/Close";

const useStyles = makeStyles((theme) => ({
    divider: {
        background: theme.palette.primary.main,
        padding: 2,
    },
    backdrop: {
        zIndex: theme.zIndex.drawer - 1,
    },
}));

export default function DrawerGallery(props) {
    const classes = useStyles();
    const {t} = useTranslation("common");
    const {manifestURL, openHandler, closeHandler, open} = props;
    const [images, setImages] = React.useState([]);

    React.useEffect(() => {
        if (manifestURL) {
            fetch(manifestURL).then((response) => {
                if (response.status >= 200 && response.status < 400) {
                    return response.json();
                }
            }).then((data) => {
                let canvases = data.sequences[0].canvases;
                let images = [];
                canvases.forEach((canvas) => {
                    canvas.images.forEach((image) => {
                        let urlImg = image.resource.service['@id'];
                        let array = urlImg.split('/');
                        let collection = array[array.indexOf('IIIF') + 1].split('!');
                        images.push({
                            src: urlImg,
                            collection: collection[0],
                            title: canvas.label,
                            format: image.resource.format,
                            width: canvas.width,
                            height: canvas.height,
                        });
                    });
                });
                setImages(images);
            }).catch((error) => {
                console.error(error);
            });
        }
    }, [manifestURL]);

    const handleOpen = () => {
        openHandler();
    }

    const handleClose = () => {
        closeHandler();
    }

    return (
        <>
            <Backdrop
                open={open}
                onClick={handleClose}
                className={classes.backdrop}
            />
            <SwipeableDrawer
                anchor="left"
                open={open}
                onClose={handleClose}
                onOpen={handleOpen}
                variant="persistent"
            >
                <Toolbar>
                    <Typography variant="h5" fontWeight="bold" color="textSecondary">
                        {t("main.components.drawer.allpages")}
                    </Typography>
                    <Box flexGrow={1} textAlign="right">
                        <IconButton onClick={handleClose}>
                            <CloseIcon/>
                        </IconButton>
                    </Box>
                </Toolbar>
                <Divider className={classes.divider}/>
                <Gallery images={images}/>
            </SwipeableDrawer>
        </>
    );
}

DrawerGallery.propTypes = {
    manifestURL: PropTypes.string.isRequired,
    openHandler: PropTypes.func,
    closeHandler: PropTypes.func,
    open: PropTypes.bool,
}

DrawerGallery.defaultProps = {
    openHandler: null,
    closeHandler: null,
    open: false,
}